import { render, staticRenderFns } from "./IndexExternal.vue?vue&type=template&id=395b53fc&scoped=true"
import script from "./IndexExternal.vue?vue&type=script&lang=js"
export * from "./IndexExternal.vue?vue&type=script&lang=js"
import style0 from "./IndexExternal.vue?vue&type=style&index=0&id=395b53fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b53fc",
  null
  
)

export default component.exports